import React, { useEffect, useState, useMemo } from "react";
import { Button, Dropdown, Modal, Form, Spinner } from "react-bootstrap";
import Select from "react-select";
import { useAuth } from "../../../firebase/AuthProvider";
import { useNavigate } from "react-router-dom";
import { getAttachmentsByTaskId } from "../../../services/taskServices/TaskAttachmentService";
import { getAttachmentRequirementsByTaskId } from "../../../services/taskServices/TaskAttachmentRequirementsService";
import { TaskRequiresAttachment } from "../../../interfaces/task/TaskFiles/TaskRequiresAttachment";
import TaskAttachment, { AttachmentResponse } from "../../../interfaces/task/TaskFiles/TaskAttachment";
import UploadFileModal from "./Modals/UploadFileModal";
import {
  createParticipantFileRequest,
  deleteFileById,
  downloadFile,
  getCanUserDeleteTaskFile,
  getTemplateFiles,
} from "../../../services/fileServices/FileService";
import { cancelSignatureRequestById } from "../../../services/fileServices/signatures/SignatureService";
import Loader from "../loader/Loader";
import { toast } from "react-toastify";
import { showConfirmationDialog } from "../../modal/ConfimationModal/Confimation";
import moment from "moment";
import { FormPageStates } from "../../../interfaces/dynamicForms/Forms";
import Task, { FileNavigationState } from "../../../interfaces/task/Task";
import ExternalFileRequestModal from "./Modals/ExternalFileRequestModal";
import {
  PenLine,
  MoreVertical,
} from "lucide-react";
import { ROLES } from "../../../Data/SD";

interface TaskAttachmentSectionProps {
  task: Task;
  taskId: string;
  reload: () => void;
  participantId?: string;
  onAttachmentCountChange: (count: number) => void;
}

const getFileIcon = (filename1: string, frp: string) => {
  let filename = filename1 ? filename1.toLocaleLowerCase() : "";
  if (filename.endsWith("pdf")) {
    return (
      <div className="relative">
        <svg xmlns="http://www.w3.org/2000/svg" width="57" height="76" viewBox="0 0 57 76" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 9.5C0 6.98044 1.00089 4.56408 2.78249 2.78249C4.56408 1.00089 6.98044 0 9.5 0H31.2835C33.8029 0.000538055 36.2188 1.00178 38 2.7835L54.2165 19C55.9982 20.7812 56.9995 23.1971 57 25.7165V66.5C57 69.0196 55.9991 71.4359 54.2175 73.2175C52.4359 74.9991 50.0196 76 47.5 76H9.5C6.98044 76 4.56408 74.9991 2.78249 73.2175C1.00089 71.4359 0 69.0196 0 66.5V9.5Z" fill="white" />
        </svg>
        <span className="absolute" style={{ bottom: "2.4rem", fontSize: "1rem", left: "50%", transform: "translateX(-50%)", fontWeight: 400, color: "#000" }}>PDF</span>
      </div>


    );
  } else if (filename.endsWith("docx") || filename.endsWith("doc")) {
    return (
      <div className="relative">
        <svg xmlns="http://www.w3.org/2000/svg" width="57" height="76" viewBox="0 0 57 76" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 9.5C0 6.98044 1.00089 4.56408 2.78249 2.78249C4.56408 1.00089 6.98044 0 9.5 0H31.2835C33.8029 0.000538055 36.2188 1.00178 38 2.7835L54.2165 19C55.9982 20.7812 56.9995 23.1971 57 25.7165V66.5C57 69.0196 55.9991 71.4359 54.2175 73.2175C52.4359 74.9991 50.0196 76 47.5 76H9.5C6.98044 76 4.56408 74.9991 2.78249 73.2175C1.00089 71.4359 0 69.0196 0 66.5V9.5Z" fill="white" />
        </svg>
        <span className="absolute" style={{ bottom: "2.4rem", fontSize: "1rem", left: "50%", transform: "translateX(-50%)", fontWeight: 400, color: "#000" }}>DOC</span>
      </div>
    );
  } else if (
    filename.endsWith("xlsx") ||
    filename.endsWith("xls") ||
    filename.endsWith("csv")
  ) {
    return (
      <div className="relative">
        <svg xmlns="http://www.w3.org/2000/svg" width="57" height="76" viewBox="0 0 57 76" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 9.5C0 6.98044 1.00089 4.56408 2.78249 2.78249C4.56408 1.00089 6.98044 0 9.5 0H31.2835C33.8029 0.000538055 36.2188 1.00178 38 2.7835L54.2165 19C55.9982 20.7812 56.9995 23.1971 57 25.7165V66.5C57 69.0196 55.9991 71.4359 54.2175 73.2175C52.4359 74.9991 50.0196 76 47.5 76H9.5C6.98044 76 4.56408 74.9991 2.78249 73.2175C1.00089 71.4359 0 69.0196 0 66.5V9.5Z" fill="white" />
        </svg>
        <span className="absolute" style={{ bottom: "2.4rem", fontSize: "1rem", left: "50%", transform: "translateX(-50%)", fontWeight: 400, color: "#000" }}>XLS</span>
      </div>
    );
  } else if (filename.endsWith("png") || filename.endsWith("jpg") || filename.endsWith("jpeg") || filename.endsWith("gif")) {
    return (
      <div className="relative">
        <svg xmlns="http://www.w3.org/2000/svg" width="57" height="76" viewBox="0 0 57 76" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 9.5C0 6.98044 1.00089 4.56408 2.78249 2.78249C4.56408 1.00089 6.98044 0 9.5 0H31.2835C33.8029 0.000538055 36.2188 1.00178 38 2.7835L54.2165 19C55.9982 20.7812 56.9995 23.1971 57 25.7165V66.5C57 69.0196 55.9991 71.4359 54.2175 73.2175C52.4359 74.9991 50.0196 76 47.5 76H9.5C6.98044 76 4.56408 74.9991 2.78249 73.2175C1.00089 71.4359 0 69.0196 0 66.5V9.5Z" fill="white" />
        </svg>
        <span className="absolute" style={{ bottom: "2.4rem", fontSize: "1rem", left: "50%", transform: "translateX(-50%)", fontWeight: 400, color: "#000" }}>{filename.endsWith("png") ? "PNG" : filename.endsWith("jpg") ? "JPG" : filename.endsWith("jpeg") ? "JPEG" : filename.endsWith("gif") ? "GIF" : ""}</span>
      </div>
    );
  }

  else {
    return (
      <div className="relative">
        <svg xmlns="http://www.w3.org/2000/svg" width="57" height="76" viewBox="0 0 57 76" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 9.5C0 6.98044 1.00089 4.56408 2.78249 2.78249C4.56408 1.00089 6.98044 0 9.5 0H31.2835C33.8029 0.000538055 36.2188 1.00178 38 2.7835L54.2165 19C55.9982 20.7812 56.9995 23.1971 57 25.7165V66.5C57 69.0196 55.9991 71.4359 54.2175 73.2175C52.4359 74.9991 50.0196 76 47.5 76H9.5C6.98044 76 4.56408 74.9991 2.78249 73.2175C1.00089 71.4359 0 69.0196 0 66.5V9.5Z" fill="white" />
        </svg>
        <span className="absolute" style={{ bottom: "2.4rem", fontSize: "1rem", left: "50%", transform: "translateX(-50%)", fontWeight: 400, color: "#000" }}>OTHER</span>
      </div>
    );
  }
};

const TaskAttachmentSection = ({
  task,
  taskId,
  reload,
  participantId,
  onAttachmentCountChange,
}: TaskAttachmentSectionProps) => {
  const { currentUser, currentRoles, currentOrganization } = useAuth();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [authToken, setAuthToken] = useState<string>("");
  const [attachments, setAttachments] = useState<AttachmentResponse[] | null>([]);
  const [attachmentRequirements, setAttachmentRequirements] = useState<
    TaskRequiresAttachment[] | null
  >([]);
  const [showUploadFileModal, setShowUploadFileModal] =
    useState<boolean>(false);
  const [showExternalFileUploadModal, setShowExternalFileUploadModal] =
    useState<boolean>(false);
  const [selectedRequiredFile, setSelectedRequiredFile] =
    useState<TaskRequiresAttachment | null>();
  const [canUserDeleteFile, setCanUserDeleteFile] = useState<boolean>(false);

  const [showRequestAttachmentModal, setShowRequestAttachmentModal] =
    useState(false);
  const [requestComment, setRequestComment] = useState("");
  const [templateFileOptions, setTemplateFileOptions] = useState<
    { value: number; label: string }[]
  >([]);
  const [selectedTemplateFiles, setSelectedTemplateFiles] = useState<number[]>(
    []
  );
  const [isRequestingAttachment, setIsRequestingAttachment] = useState(false);
  const [isCancellingSignature, setIsCancellingSignature] = useState(false);
  const [scrollContainer, setScrollContainer] = useState<HTMLDivElement | null>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  useEffect(() => {
    if (!currentUser || !taskId) return;
    currentUser.getIdToken().then((token) => {
      setAuthToken(token);
      fetchTaskAttachments(token);
      fetchTaskAttachmentRequirements(token);
      fetchCanUserDeleteTaskFiles(token);
      fetchTemplateFiles(token);
    });
  }, [taskId, currentUser]);

  useEffect(() => {
    onAttachmentCountChange(attachments?.length || 0);
  }, [attachments, onAttachmentCountChange]);

  // Check scroll position to show/hide arrows
  useEffect(() => {
    const checkScrollPosition = () => {
      if (!scrollContainer) {
        setCanScrollLeft(false);
        setCanScrollRight(false);
        return;
      }

      const { scrollLeft, scrollWidth, clientWidth } = scrollContainer;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 1); // -1 for rounding issues
    };

    checkScrollPosition();

    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', checkScrollPosition);
      window.addEventListener('resize', checkScrollPosition);

      // Check after a short delay to ensure DOM is fully rendered
      const timeoutId = setTimeout(checkScrollPosition, 100);

      return () => {
        scrollContainer.removeEventListener('scroll', checkScrollPosition);
        window.removeEventListener('resize', checkScrollPosition);
        clearTimeout(timeoutId);
      };
    }
  }, [scrollContainer, attachments, attachmentRequirements]);

  const fetchTaskAttachments = async (token: string) => {
    setIsLoading(true);
    try {
      const fetchedAttachments = await getAttachmentsByTaskId(taskId, token);
      setAttachments(fetchedAttachments);
    } catch (error) {
      console.error("Error fetching attachments:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTaskAttachmentRequirements = async (token: string) => {
    try {
      const fetchedAttachmentRequirements =
        await getAttachmentRequirementsByTaskId(taskId, token);
      setAttachmentRequirements(fetchedAttachmentRequirements);
    } catch (error) {
      console.error("Error fetching attachment requirements:", error);
      toast.error("Failed to load attachment requirements.");
    }
  };

  const fetchCanUserDeleteTaskFiles = async (token: string) => {
    try {
      const response = await getCanUserDeleteTaskFile(token, taskId);
      setCanUserDeleteFile(response);
    } catch (error) {
      console.error("Error fetching delete permission:", error);
    }
  };

  const fetchTemplateFiles = async (token: string) => {
    try {
      const fetchedTemplateFiles = await getTemplateFiles(token);
      if (fetchedTemplateFiles != null) {
        const mappedOptions = fetchedTemplateFiles.map((file: any) => ({
          value: file.id,
          label: file.fileName,
        }));
        setTemplateFileOptions(mappedOptions);
      }
    } catch (error) {
      console.error("Error fetching template files:", error);
    }
  };

  const refreshAttachments = () => {
    fetchTaskAttachments(authToken);
    fetchTaskAttachmentRequirements(authToken);
    reload();
  };

  const handleCloseUploadFileModal = () => {
    setShowUploadFileModal(false);
    setSelectedRequiredFile(null);
  };

  const handleShowUploadFileModal = (item?: TaskRequiresAttachment) => {
    item ? setSelectedRequiredFile(item) : setSelectedRequiredFile(null);
    setShowUploadFileModal(true);
  };

  const handleView = (item: AttachmentResponse) => {
    navigate(`/view/file/${item.file.id}`, {
      state: {
        taskId: Number(task.id) ?? null,
        taskTitle: task.title ?? null,
      } satisfies FileNavigationState,
    });
  };

  const handleDownload = async (fileId: string, filename: string) => {
    try {
      if (!currentUser) return;
      const token = await currentUser.getIdToken();
      const blob = await downloadFile(fileId, token);
      if (blob) {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      toast.error("Failed to download file.");
    }
  };

  const handleCancelSignatureRequest = async (signatureBoxId: string) => {
    if (!signatureBoxId) {
      toast.error("No signature request found to cancel.");
      return;
    }

    // Show confirmation dialog
    const isConfirm = await showConfirmationDialog(
      "Cancel eSign Request",
      "Are you sure you want to cancel this request? This will stop any pending signatures.",
      "Cancel Request",
      "Keep Request",
      "warning"
    );

    if (!isConfirm) return;

    // Prevent duplicate submissions
    if (isCancellingSignature) return;

    try {
      setIsCancellingSignature(true);
      const token = await currentUser?.getIdToken();
      if (!token) {
        toast.error("Authentication required.");
        setIsCancellingSignature(false);
        return;
      }

      const result = await cancelSignatureRequestById(token, signatureBoxId);

      if (result.success) {
        // Extract proper message from result
        let successMessage = "Signature request cancelled successfully!";
        if (result.message) {
          // Try to parse if it's a JSON string
          try {
            const parsed = JSON.parse(result.message);
            // Extract data field (contains the actual message) or fall back to message field
            successMessage = parsed.data || parsed.message || successMessage;
          } catch {
            // If not JSON, use the string directly
            successMessage = result.message;
          }
        }
        toast.success(successMessage);
        refreshAttachments();
      } else {
        // Extract proper error message from result
        let errorMessage = "Failed to cancel signature request";
        if (result.message) {
          // Try to parse if it's a JSON string
          try {
            const parsed = JSON.parse(result.message);
            errorMessage = parsed.data || parsed.message || parsed.error || errorMessage;
          } catch {
            // If not JSON, use the string directly
            errorMessage = result.message;
          }
        }
        toast.error(errorMessage);
      }
    } catch (error: any) {
      console.error("Error cancelling signature request:", error);
      // Extract proper error message from error object
      let errorMessage = "Failed to cancel signature request";
      if (error?.message) {
        errorMessage = typeof error.message === 'string' ? error.message : errorMessage;
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      }
      toast.error(errorMessage);
    } finally {
      setIsCancellingSignature(false);
    }
  };

  const handleSignatureRequest = (item: AttachmentResponse) => {
    navigate(`/edit/file/${item.file.id}`, {
      state: {
        taskId: Number(task.id) ?? null,
        taskTitle: task.title ?? null,
      } satisfies FileNavigationState,
    });
  };

  const handleClickDelete = async (item: AttachmentResponse) => {
    const isConfirm = await showConfirmationDialog(
      "Are you sure you want to delete this file?"
    );
    if (!isConfirm) return;
    try {
      setIsLoading(true);
      const token = await currentUser?.getIdToken();
      if (token) {
        await deleteFileById(item.file.id, token);
        toast.success("File Deleted Successfully");
        refreshAttachments();
      }
    } catch (error: any) {
      toast.error(error.message || "Failed to delete file.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditAndCreateNewVersion = (item: AttachmentResponse) => {
    const formId = (item as any).form?.name;
    if (!formId) {
      toast.error("Cannot open form, form ID is missing.");
      return;
    }
    const assignee = task.assignees?.find(
      (a) => !a.isCoAssignee && !a.isReporter
    );
    const scid = assignee?.user.scId;
    console.log('Contact Types', task.subType);
    console.log('Waiver Type', task.participant.waiver)
    const states: FormPageStates = {
      FormId: formId.toString(),
      participantId: participantId,
      taskId: taskId,
      // contactType: task.subType?.type?.toString(),
      contactType: "Interim",
      waiverType: task.participant?.waiver || {},
      scid: scid || "",
      organizationName: currentOrganization?.name || "",
      participantName:
        task.participant?.firstName + " " + task.participant?.lastName,
    };
    navigate("/form/fill", { state: states });
  };

  const handleFillForm = (item: TaskRequiresAttachment) => {
    const formId = item.templateFile.form?.name;
    if (!formId) {
      toast.error("Cannot open form, form ID is missing.");
      return;
    }
    const assignee = task.assignees?.find(
      (a) => !a.isCoAssignee && !a.isReporter
    );
    const scid = assignee?.user?.scId;
    const states: FormPageStates = {
      FormId: formId.toString(),
      participantId: participantId,
      taskId: taskId,
      // contactType: task.subType?.id?.toString(),
      contactType: "Interim",
      waiverType: task.participant?.waiver,
      scid: scid || "",
      organizationName: currentOrganization?.name || "",
      participantName:
        task.participant?.firstName + " " + task.participant?.lastName,
    };
    navigate("/form/fill", { state: states });
  };

  const handleRequestAttachment = async () => {
    if (!currentUser || !taskId || selectedTemplateFiles.length === 0) return;
    setIsRequestingAttachment(true);
    try {
      const token = await currentUser.getIdToken();
      const payload = {
        taskId: Number(taskId),
        employeeId: currentUser.uid,
        participantId: Number(participantId),
        templateTypeIds: selectedTemplateFiles,
        comment: requestComment,
      };
      await createParticipantFileRequest(token, payload);
      toast.success("Attachment request submitted successfully!");
      setShowRequestAttachmentModal(false);
      setRequestComment("");
      setSelectedTemplateFiles([]);
      refreshAttachments();
    } catch (error: any) {
      console.error("Error creating attachment request:", error);
      toast.error(error.message || "Failed to submit attachment request.");
    } finally {
      setIsRequestingAttachment(false);
    }
  };

  const totalSizeMB = useMemo(() => {
    const totalBytes =
      attachments?.reduce((sum, att) => sum + (att.file?.size || 0), 0) || 0;
    return (totalBytes / (1024 * 1024)).toFixed(1);
  }, [attachments]);

  const totalFiles = attachments?.length || 0;

  const handleScrollLeft = () => {
    if (scrollContainer) {
      scrollContainer.scrollBy({ left: -300, behavior: 'smooth' });
      // Update scroll state after a short delay to allow smooth scroll to complete
      setTimeout(() => {
        if (scrollContainer) {
          const { scrollLeft, scrollWidth, clientWidth } = scrollContainer;
          setCanScrollLeft(scrollLeft > 0);
          setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 1);
        }
      }, 100);
    }
  };

  const handleScrollRight = () => {
    if (scrollContainer) {
      scrollContainer.scrollBy({ left: 300, behavior: 'smooth' });
      // Update scroll state after a short delay to allow smooth scroll to complete
      setTimeout(() => {
        if (scrollContainer) {
          const { scrollLeft, scrollWidth, clientWidth } = scrollContainer;
          setCanScrollLeft(scrollLeft > 0);
          setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 1);
        }
      }, 100);
    }
  };


  const SliderArrowIcon = ({ direction, filterId }: { direction: 'left' | 'right'; filterId: string }) => (
    <svg
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: direction === 'left' ? 'rotate(180deg)' : 'none' }}
    >
      <g filter={`url(#${filterId})`}>
        <circle cx="27.0386" cy="25.7822" r="21.3998" fill="white" stroke="white" strokeWidth="1.22285" />
        <path d="M34.641 26.3445C34.9514 26.034 34.9514 25.5308 34.641 25.2204L29.5826 20.162C29.2722 19.8516 28.7689 19.8516 28.4585 20.162C28.1481 20.4724 28.1481 20.9756 28.4585 21.2861L32.9549 25.7824L28.4585 30.2788C28.1481 30.5892 28.1481 31.0924 28.4585 31.4028C28.7689 31.7133 29.2722 31.7133 29.5826 31.4028L34.641 26.3445ZM19.1113 25.7824L19.1113 26.5773L34.079 26.5773L34.079 25.7824L34.079 24.9876L19.1113 24.9876L19.1113 25.7824Z" fill="#7E57C2" />
      </g>
      <defs>
        <filter id={filterId} x="-0.000566959" y="1.19209e-07" width="54.0773" height="54.0783" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1.25698" />
          <feGaussianBlur stdDeviation="2.51396" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3936_6701" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3936_6701" result="shape" />
        </filter>
      </defs>
    </svg>
  );

  if (isLoading) return <Loader />;


  console.log('Attachments', attachments)

  return (
    <div className="task-attachment-section">
      <div className="attachment-header-section">
        <div className="attachment-header-left">
          <h4 className="attachment-title">Attachments</h4>
          <span className="attachment-summary-text">
            {totalFiles} files • {totalSizeMB} MB Total
          </span>
        </div>
        <div className="attachment-header-right">

          {/* TEMP: Single option button. Uncomment Dropdown below when multiple options are available. */}
          <button
            type="button"
            className="request-attachment-dropdown-btn"
            onClick={() => setShowExternalFileUploadModal(true)}
            style={{ backgroundColor: 'transparent', border: '1px solid #dee2e6' }} // Ensure basic outline style if class doesn't cover it
          >
            Request Attachment
          </button>

          {/* <Dropdown align="end">
            <Dropdown.Toggle
              variant="outline"
              className="request-attachment-dropdown-btn"
            >
              Request attachment
              <ChevronDown size={16} className="dropdown-chevron" />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setShowRequestAttachmentModal(true)}>
                Request Template Attachment
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setShowExternalFileUploadModal(true)}>
                Request External Attachment
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown> 
          */}

          <div onClick={() => handleShowUploadFileModal()} style={{ cursor: 'pointer' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
              <circle cx="15" cy="15" r="15" fill="#F4F4F4" />
              <path d="M21.0503 15H15.0251M15.0251 15H9M15.0251 15V9M15.0251 15V21" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>

        </div>
      </div>

      <div className="attachment-cards-wrapper">
        {((attachments?.length ?? 0) > 0 || (attachmentRequirements?.length ?? 0) > 0) && canScrollLeft && (
          <button
            className="attachment-slider-arrow attachment-slider-arrow-left"
            onClick={handleScrollLeft}
            aria-label="Scroll left"
          >
            <SliderArrowIcon direction="left" filterId="filter_arrow_left" />
          </button>
        )}
        <div
          className="attachment-cards-container"
          ref={setScrollContainer}
        >
          <div className="attachment-cards-scroll">
            {attachments?.length === 0 && attachmentRequirements?.length === 0 ? (
              <div className="no-attachments">
                No attachments found for this task.
              </div>
            ) : (
              <>
                {attachmentRequirements?.map((item) => {
                  return (

                    <div key={item.id} className="attachment-card-item attachment-required-card">
                      <div className="attachment-card-icon-wrapper">
                        {getFileIcon(item.templateFile.type?.type, "2")}
                      </div>
                      <div className="attachment-card-content px-2.5">
                        <div className="attachment-card-name">{item.templateFile.fileName}</div>
                        <div className="attachment-card-meta required-text">
                          Required file • Please upload
                        </div>
                      </div>
                      <div className="attachment-card-bottom-grid">
                        <Button
                          onClick={() => handleShowUploadFileModal(item)}
                          className="attachment-upload-btn"
                        >
                          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.57143 9.066V1.65171L3.57429 3.64886L2.96743 3.03343L6 0L9.03343 3.03343L8.42657 3.64971L6.42857 1.65171V9.066H5.57143ZM1.38514 12C0.990286 12 0.660857 11.868 0.396857 11.604C0.132857 11.34 0.000571429 11.0103 0 10.6149V8.538H0.857143V10.6149C0.857143 10.7469 0.912 10.868 1.02171 10.9783C1.13143 11.0886 1.25229 11.1434 1.38429 11.1429H10.6157C10.7471 11.1429 10.868 11.088 10.9783 10.9783C11.0886 10.8686 11.1434 10.7474 11.1429 10.6149V8.538H12V10.6149C12 11.0097 11.868 11.3391 11.604 11.6031C11.34 11.8671 11.0103 11.9994 10.6149 12H1.38514Z" fill="#747474" />
                          </svg>

                          Upload
                        </Button>
                        <div className="attachment-card-actions-bottom">
                          {item.templateFile.form && <Dropdown align="end" className="file-options-dropdown">
                            <Dropdown.Toggle
                              variant="link"
                              id={`dropdown-required-${item.id}`}
                            >
                              <MoreVertical size={18} />
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                              renderOnMount
                              popperConfig={{
                                strategy: "fixed",
                              }}
                            >
                              <Dropdown.Item onClick={() => handleFillForm(item)}>
                                <div className="dropdown-item-content">
                                  <PenLine size={18} />
                                  <span>Fill Form</span>
                                </div>
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>}
                        </div>
                      </div>
                    </div>
                  );
                })}

                {attachments?.map((item) => {
                  let fileSizeKB = 0;
                  let fileSizeDisplay = "--";
                  if (item.file.size) {
                    fileSizeKB = Math.round(item.file.size / 1024);
                    fileSizeDisplay = fileSizeKB >= 1024
                      ? `${(fileSizeKB / 1024).toFixed(1)} MB`
                      : `${fileSizeKB} KB`;
                  }

                  // Convert UTC to local timezone before using fromNow()
                  // Handle UTC strings that may not have 'Z' suffix (like TaskPage pattern)
                  let uploadDate: moment.Moment;
                  if (item.file.updateDate) {
                    const dateString = typeof item.file.updateDate === 'string'
                      ? item.file.updateDate
                      : String(item.file.updateDate);
                    // If string has 'T' but no 'Z' or timezone offset, append 'Z' to treat as UTC
                    if (dateString.includes('T') && !dateString.includes('Z') && !dateString.includes('GMT') && !dateString.match(/[+-]\d{2}:\d{2}$/)) {
                      uploadDate = moment.utc(dateString + 'Z').local();
                    } else {
                      uploadDate = moment.utc(dateString).local();
                    }
                  } else {
                    uploadDate = moment();
                  }
                  const uploaderName = item.file.author?.displayName || item.file.author?.firstName + " " + item.file.author?.lastName || "Unknown";

                  return (
                    <div key={item.file.id} className="attachment-card-item">
                      <div className="attachment-card-icon-wrapper">
                        {getFileIcon(item.file.type.type, "2")}
                        <div className="attachment-card-size bg-[#FFF]">{fileSizeDisplay}</div>
                      </div>

                      <div className="attachment-card-content px-2.5 mb-2">
                        <div className="attachment-card-name">{item.file.fileName}</div>
                        <div className="attachment-card-meta">
                          {uploadDate.fromNow()} • Uploaded by <span>{uploaderName}</span>
                        </div>
                      </div>
                      <div className="attachment-card-actions-top">
                        <button
                          className="attachment-download-icon bg-[#F9F6FF] rounded-2"
                          onClick={() => handleDownload(item.file.id, item.file.fileName)}
                          title="Download"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <rect width="20" height="20" rx="4" fill="#F9F6FF" />
                            <path d="M10 12.6812C9.9 12.6812 9.80625 12.6657 9.71875 12.6347C9.63125 12.6038 9.55 12.5505 9.475 12.475L6.775 9.775C6.625 9.625 6.553 9.45 6.559 9.25C6.565 9.05 6.637 8.875 6.775 8.725C6.925 8.575 7.10325 8.497 7.30975 8.491C7.51625 8.485 7.69425 8.55675 7.84375 8.70625L9.25 10.1125V4.75C9.25 4.5375 9.322 4.3595 9.466 4.216C9.61 4.0725 9.788 4.0005 10 4C10.212 3.9995 10.3902 4.0715 10.5347 4.216C10.6792 4.3605 10.751 4.5385 10.75 4.75V10.1125L12.1562 8.70625C12.3062 8.55625 12.4845 8.48425 12.691 8.49025C12.8975 8.49625 13.0755 8.5745 13.225 8.725C13.3625 8.875 13.4345 9.05 13.441 9.25C13.4475 9.45 13.3755 9.625 13.225 9.775L10.525 12.475C10.45 12.55 10.3687 12.6032 10.2812 12.6347C10.1937 12.6663 10.1 12.6818 10 12.6812ZM5.5 16C5.0875 16 4.7345 15.8532 4.441 15.5597C4.1475 15.2662 4.0005 14.913 4 14.5V13C4 12.7875 4.072 12.6095 4.216 12.466C4.36 12.3225 4.538 12.2505 4.75 12.25C4.962 12.2495 5.14025 12.3215 5.28475 12.466C5.42925 12.6105 5.501 12.7885 5.5 13V14.5H14.5V13C14.5 12.7875 14.572 12.6095 14.716 12.466C14.86 12.3225 15.038 12.2505 15.25 12.25C15.462 12.2495 15.6402 12.3215 15.7847 12.466C15.9292 12.6105 16.001 12.7885 16 13V14.5C16 14.9125 15.8532 15.2657 15.5597 15.5597C15.2662 15.8537 14.913 16.0005 14.5 16H5.5Z" fill="#747474" />
                          </svg>
                        </button>
                      </div>
                      <div className="attachment-card-bottom-grid">
                        {(item as any).signatureStatus ? (
                          <div className="attachment-upload-btn btn btn-primary">
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4.425 9.725C5.64167 8.825 6.59167 7.83767 7.275 6.763C7.95833 5.68833 8.3 4.61733 8.3 3.55C8.3 3.01667 8.21267 2.625 8.038 2.375C7.86333 2.125 7.62567 2 7.325 2C6.54167 2 5.85 2.66267 5.25 3.988C4.65 5.31333 4.35 6.809 4.35 8.475C4.35 8.70833 4.35433 8.92933 4.363 9.138C4.37167 9.34667 4.39233 9.54233 4.425 9.725ZM5.8 14C5.3 14 4.84167 13.904 4.425 13.712C4.00833 13.52 3.65 13.208 3.35 12.776C2.93333 13.0093 2.50433 13.2177 2.063 13.401C1.62167 13.5843 1.16733 13.7677 0.700001 13.951L0 12.076C0.466667 11.9093 0.912667 11.7303 1.338 11.539C1.76333 11.3477 2.17567 11.1433 2.575 10.926C2.49167 10.5593 2.42933 10.1593 2.388 9.726C2.34667 9.29267 2.32567 8.826 2.325 8.326C2.325 5.926 2.8 3.93867 3.75 2.364C4.7 0.789333 5.89167 0.00133333 7.325 0C8.19167 0 8.9 0.321 9.45 0.963C10 1.605 10.275 2.50067 10.275 3.65C10.275 5.08333 9.821 6.5 8.913 7.9C8.005 9.3 6.74233 10.5583 5.125 11.675C5.24167 11.7917 5.36267 11.8793 5.488 11.938C5.61333 11.9967 5.74233 12.0257 5.875 12.025C6.30833 12.025 6.81267 11.75 7.388 11.2C7.96333 10.65 8.484 9.925 8.95 9.025L10.775 9.875C10.6583 10.1583 10.5667 10.5 10.5 10.9C10.4333 11.3 10.4417 11.65 10.525 11.95C10.6917 11.8667 10.8877 11.725 11.113 11.525C11.3383 11.325 11.5673 11.075 11.8 10.775L13.375 12C12.9417 12.6 12.4417 13.0833 11.875 13.45C11.3083 13.8167 10.7833 14 10.3 14C9.95 14 9.63767 13.896 9.363 13.688C9.08833 13.48 8.859 13.159 8.675 12.725C8.20833 13.1417 7.73333 13.4583 7.25 13.675C6.76667 13.8917 6.28333 14 5.8 14Z" fill="#747474" />
                            </svg>

                            <span>{(item as any).signatureStatus
                              ? (item as any).signatureStatus.charAt(0).toUpperCase() + (item as any).signatureStatus.slice(1).toLowerCase()
                              : ""}</span>
                          </div>
                        ) : (item as any).file.signed ? (
                          <div className="attachment-upload-btn-success btn btn-primary">
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M4.425 9.725C5.64167 8.825 6.59167 7.83767 7.275 6.763C7.95833 5.68833 8.3 4.61733 8.3 3.55C8.3 3.01667 8.21267 2.625 8.038 2.375C7.86333 2.125 7.62567 2 7.325 2C6.54167 2 5.85 2.66267 5.25 3.988C4.65 5.31333 4.35 6.809 4.35 8.475C4.35 8.70833 4.35433 8.92933 4.363 9.138C4.37167 9.34667 4.39233 9.54233 4.425 9.725ZM5.8 14C5.3 14 4.84167 13.904 4.425 13.712C4.00833 13.52 3.65 13.208 3.35 12.776C2.93333 13.0093 2.50433 13.2177 2.063 13.401C1.62167 13.5843 1.16733 13.7677 0.700001 13.951L0 12.076C0.466667 11.9093 0.912667 11.7303 1.338 11.539C1.76333 11.3477 2.17567 11.1433 2.575 10.926C2.49167 10.5593 2.42933 10.1593 2.388 9.726C2.34667 9.29267 2.32567 8.826 2.325 8.326C2.325 5.926 2.8 3.93867 3.75 2.364C4.7 0.789333 5.89167 0.00133333 7.325 0C8.19167 0 8.9 0.321 9.45 0.963C10 1.605 10.275 2.50067 10.275 3.65C10.275 5.08333 9.821 6.5 8.913 7.9C8.005 9.3 6.74233 10.5583 5.125 11.675C5.24167 11.7917 5.36267 11.8793 5.488 11.938C5.61333 11.9967 5.74233 12.0257 5.875 12.025C6.30833 12.025 6.81267 11.75 7.388 11.2C7.96333 10.65 8.484 9.925 8.95 9.025L10.775 9.875C10.6583 10.1583 10.5667 10.5 10.5 10.9C10.4333 11.3 10.4417 11.65 10.525 11.95C10.6917 11.8667 10.8877 11.725 11.113 11.525C11.3383 11.325 11.5673 11.075 11.8 10.775L13.375 12C12.9417 12.6 12.4417 13.0833 11.875 13.45C11.3083 13.8167 10.7833 14 10.3 14C9.95 14 9.63767 13.896 9.363 13.688C9.08833 13.48 8.859 13.159 8.675 12.725C8.20833 13.1417 7.73333 13.4583 7.25 13.675C6.76667 13.8917 6.28333 14 5.8 14Z"
                                fill="#059669"
                              />
                            </svg>
                            <span>Signed</span>
                          </div>
                        ) : null}
                        <div className="attachment-card-actions-bottom">
                          <Dropdown align="end" className="file-options-dropdown">
                            <Dropdown.Toggle
                              variant="link"
                              id={`dropdown-file-${item.file.id}`}
                            >
                              <MoreVertical size={18} />
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                              renderOnMount
                              popperConfig={{
                                strategy: "fixed",
                              }}
                            >
                              <Dropdown.Item onClick={() => handleView(item)}>
                                <div className="dropdown-item-content">
                                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.465 6.90313C13.655 7.16938 13.75 7.30313 13.75 7.5C13.75 7.6975 13.655 7.83062 13.465 8.09687C12.6113 9.29437 10.4306 11.875 7.5 11.875C4.56875 11.875 2.38875 9.29375 1.535 8.09687C1.345 7.83062 1.25 7.69687 1.25 7.5C1.25 7.3025 1.345 7.16938 1.535 6.90313C2.38875 5.70563 4.56937 3.125 7.5 3.125C10.4313 3.125 12.6113 5.70625 13.465 6.90313Z" stroke="#313131" stroke-width="1.125" />
                                    <path d="M9.375 7.5C9.375 7.00272 9.17746 6.52581 8.82583 6.17417C8.47419 5.82254 7.99728 5.625 7.5 5.625C7.00272 5.625 6.52581 5.82254 6.17417 6.17417C5.82254 6.52581 5.625 7.00272 5.625 7.5C5.625 7.99728 5.82254 8.47419 6.17417 8.82583C6.52581 9.17746 7.00272 9.375 7.5 9.375C7.99728 9.375 8.47419 9.17746 8.82583 8.82583C9.17746 8.47419 9.375 7.99728 9.375 7.5Z" stroke="#313131" stroke-width="1.125" />
                                  </svg>

                                  <span>View</span>
                                </div>
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() =>
                                  handleDownload(item.file.id, item.file.fileName)
                                }
                              >
                                <div className="dropdown-item-content">
                                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.99999 10.1281C6.88333 10.1281 6.77395 10.11 6.67187 10.0739C6.56979 10.0377 6.47499 9.97558 6.3875 9.8875L3.2375 6.7375C3.0625 6.5625 2.9785 6.35833 2.9855 6.125C2.9925 5.89167 3.0765 5.6875 3.2375 5.5125C3.4125 5.3375 3.62046 5.2465 3.86137 5.2395C4.10229 5.2325 4.30995 5.31621 4.48437 5.49063L6.125 7.13125V0.875003C6.125 0.627086 6.20899 0.41942 6.377 0.252003C6.54499 0.0845864 6.75266 0.00058635 6.99999 3.01724e-06C7.24733 -0.000580316 7.45529 0.0834198 7.62387 0.252003C7.79245 0.420586 7.87616 0.628253 7.87499 0.875003V7.13125L9.51562 5.49063C9.69062 5.31563 9.89858 5.23163 10.1395 5.23863C10.3804 5.24563 10.5881 5.33692 10.7625 5.5125C10.9229 5.6875 11.0069 5.89167 11.0145 6.125C11.0221 6.35833 10.9381 6.5625 10.7625 6.7375L7.61249 9.8875C7.52499 9.975 7.4302 10.0371 7.32812 10.0739C7.22604 10.1106 7.11666 10.1287 6.99999 10.1281ZM1.75 14C1.26875 14 0.856916 13.8288 0.514499 13.4864C0.172083 13.144 0.000583333 12.7318 0 12.25V10.5C0 10.2521 0.084 10.0444 0.252 9.877C0.42 9.70958 0.627666 9.62558 0.874999 9.625C1.12233 9.62442 1.33029 9.70842 1.49887 9.877C1.66746 10.0456 1.75117 10.2533 1.75 10.5V12.25H12.25V10.5C12.25 10.2521 12.334 10.0444 12.502 9.877C12.67 9.70958 12.8777 9.62558 13.125 9.625C13.3723 9.62442 13.5803 9.70842 13.7489 9.877C13.9174 10.0456 14.0012 10.2533 14 10.5V12.25C14 12.7312 13.8288 13.1434 13.4864 13.4864C13.1439 13.8294 12.7318 14.0006 12.25 14H1.75Z" fill="#313131" />
                                  </svg>

                                  <span>Download</span>
                                </div>
                              </Dropdown.Item>
                              {item.pendingSignatureRequest && ((currentUser?.uid && item.pendingSignRequesterIds?.includes(currentUser.uid)) ||
                                currentRoles?.some(role => role.name === ROLES.OWNER) || currentRoles?.some(role => role.name === ROLES.PROGRAM_MANAGER)
                              ) ? (
                                <Dropdown.Item
                                  onClick={() => {
                                    const signatureBoxId = item.file?.signatureBoxId ||
                                      (item as any).signatureBoxId;

                                    if (!signatureBoxId) {
                                      toast.error("Signature box ID is missing. Cannot cancel signature request.");
                                      return;
                                    }

                                    handleCancelSignatureRequest(signatureBoxId);
                                  }}
                                  disabled={isCancellingSignature}
                                  title="Cancel this signature request."
                                >
                                  <div className="dropdown-item-content">
                                    {isCancellingSignature ? (
                                      <Spinner animation="border" size="sm" style={{ width: "14px", height: "14px", marginRight: "8px" }} />
                                    ) : (
                                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7 0C3.15 0 0 3.15 0 7C0 10.85 3.15 14 7 14C10.85 14 14 10.85 14 7C14 3.15 10.85 0 7 0ZM7 12.6C3.915 12.6 1.4 10.085 1.4 7C1.4 3.915 3.915 1.4 7 1.4C10.085 1.4 12.6 3.915 12.6 7C12.6 10.085 10.085 12.6 7 12.6ZM9.8 4.9L7.7 7L9.8 9.1C10.085 9.385 10.085 9.815 9.8 10.1C9.6575 10.2425 9.4575 10.314 9.2575 10.314C9.0575 10.314 8.8575 10.2425 8.715 10.1L7 8.385L5.285 10.1C5.1425 10.2425 4.9425 10.314 4.7425 10.314C4.5425 10.314 4.3425 10.2425 4.2 10.1C3.915 9.815 3.915 9.385 4.2 9.1L6.3 7L4.2 4.9C3.915 4.615 3.915 4.185 4.2 3.9C4.485 3.615 4.915 3.615 5.2 3.9L7 5.7L8.8 3.9C9.085 3.615 9.515 3.615 9.8 3.9C10.085 4.185 10.085 4.615 9.8 4.9Z" fill="#313131" />
                                      </svg>
                                    )}
                                    <span>Cancel Request</span>
                                  </div>
                                </Dropdown.Item>
                              ) : null}
                              {(item as any).isFormFillable && (
                                <Dropdown.Item
                                  onClick={() => handleEditAndCreateNewVersion(item)}
                                >
                                  <div className="dropdown-item-content">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M7.77778 0C7.97602 0.000219884 8.16669 0.0761282 8.31084 0.212215C8.45499 0.348303 8.54174 0.534297 8.55336 0.732196C8.56497 0.930095 8.50059 1.12496 8.37335 1.27698C8.24611 1.429 8.06563 1.5267 7.86878 1.55011L7.77778 1.55556H1.55556V12.4444H12.4444V6.22222C12.4447 6.02398 12.5206 5.83331 12.6567 5.68916C12.7927 5.54501 12.9787 5.45826 13.1766 5.44664C13.3745 5.43503 13.5694 5.49941 13.7214 5.62665C13.8734 5.75389 13.9711 5.93437 13.9946 6.13122L14 6.22222V12.4444C14.0001 12.8369 13.8519 13.2149 13.5851 13.5026C13.3182 13.7904 12.9525 13.9667 12.5611 13.9961L12.4444 14H1.55556C1.16311 14.0001 0.785115 13.8519 0.497352 13.5851C0.209588 13.3182 0.0333227 12.9525 0.00388906 12.5611L7.79862e-08 12.4444V1.55556C-0.000124117 1.16311 0.148094 0.785115 0.414942 0.497352C0.68179 0.209588 1.04755 0.0333226 1.43889 0.00388898L1.55556 0H7.77778ZM12.6334 0.266778C12.7734 0.127285 12.9612 0.0462984 13.1587 0.040267C13.3563 0.0342357 13.5487 0.103612 13.6969 0.234305C13.8451 0.364997 13.938 0.547207 13.9568 0.743925C13.9755 0.940642 13.9187 1.13712 13.7978 1.29344L13.7332 1.36733L6.03322 9.06656C5.89326 9.20605 5.70544 9.28703 5.50792 9.29307C5.31041 9.2991 5.118 9.22972 4.96978 9.09903C4.82157 8.96834 4.72865 8.78613 4.70991 8.58941C4.69117 8.39269 4.74801 8.19622 4.86889 8.03989L4.93344 7.96678L12.6334 0.266778Z" fill="#313131" />
                                    </svg>

                                    <span>Fill Form</span>
                                  </div>
                                </Dropdown.Item>
                              )}
                              {!item.pendingSignatureRequest && (
                                <Dropdown.Item
                                  onClick={() => handleSignatureRequest(item)}
                                  title="Request a signature for this document."
                                >
                                  <div className="dropdown-item-content">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M4.425 9.725C5.64167 8.825 6.59167 7.83767 7.275 6.763C7.95833 5.68833 8.3 4.61733 8.3 3.55C8.3 3.01667 8.21267 2.625 8.038 2.375C7.86333 2.125 7.62567 2 7.325 2C6.54167 2 5.85 2.66267 5.25 3.988C4.65 5.31333 4.35 6.809 4.35 8.475C4.35 8.70833 4.35433 8.92933 4.363 9.138C4.37167 9.34667 4.39233 9.54233 4.425 9.725ZM5.8 14C5.3 14 4.84167 13.904 4.425 13.712C4.00833 13.52 3.65 13.208 3.35 12.776C2.93333 13.0093 2.50433 13.2177 2.063 13.401C1.62167 13.5843 1.16733 13.7677 0.700001 13.951L0 12.076C0.466667 11.9093 0.912667 11.7303 1.338 11.539C1.76333 11.3477 2.17567 11.1433 2.575 10.926C2.49167 10.5593 2.42933 10.1593 2.388 9.726C2.34667 9.29267 2.32567 8.826 2.325 8.326C2.325 5.926 2.8 3.93867 3.75 2.364C4.7 0.789333 5.89167 0.00133333 7.325 0C8.19167 0 8.9 0.321 9.45 0.963C10 1.605 10.275 2.50067 10.275 3.65C10.275 5.08333 9.821 6.5 8.913 7.9C8.005 9.3 6.74233 10.5583 5.125 11.675C5.24167 11.7917 5.36267 11.8793 5.488 11.938C5.61333 11.9967 5.74233 12.0257 5.875 12.025C6.30833 12.025 6.81267 11.75 7.388 11.2C7.96333 10.65 8.484 9.925 8.95 9.025L10.775 9.875C10.6583 10.1583 10.5667 10.5 10.5 10.9C10.4333 11.3 10.4417 11.65 10.525 11.95C10.6917 11.8667 10.8877 11.725 11.113 11.525C11.3383 11.325 11.5673 11.075 11.8 10.775L13.375 12C12.9417 12.6 12.4417 13.0833 11.875 13.45C11.3083 13.8167 10.7833 14 10.3 14C9.95 14 9.63767 13.896 9.363 13.688C9.08833 13.48 8.859 13.159 8.675 12.725C8.20833 13.1417 7.73333 13.4583 7.25 13.675C6.76667 13.8917 6.28333 14 5.8 14Z" fill="#313131" />
                                    </svg>

                                    <span>Sign</span>
                                  </div>
                                </Dropdown.Item>
                              )}

                              {item.pendingSignatureRequest && currentUser?.uid && item.pendingSignRequesterIds?.includes(currentUser.uid) && (
                                <Dropdown.Item
                                  onClick={() => handleSignatureRequest(item)}
                                  title="Request a signature for this document."
                                >
                                  <div className="dropdown-item-content">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M4.425 9.725C5.64167 8.825 6.59167 7.83767 7.275 6.763C7.95833 5.68833 8.3 4.61733 8.3 3.55C8.3 3.01667 8.21267 2.625 8.038 2.375C7.86333 2.125 7.62567 2 7.325 2C6.54167 2 5.85 2.66267 5.25 3.988C4.65 5.31333 4.35 6.809 4.35 8.475C4.35 8.70833 4.35433 8.92933 4.363 9.138C4.37167 9.34667 4.39233 9.54233 4.425 9.725ZM5.8 14C5.3 14 4.84167 13.904 4.425 13.712C4.00833 13.52 3.65 13.208 3.35 12.776C2.93333 13.0093 2.50433 13.2177 2.063 13.401C1.62167 13.5843 1.16733 13.7677 0.700001 13.951L0 12.076C0.466667 11.9093 0.912667 11.7303 1.338 11.539C1.76333 11.3477 2.17567 11.1433 2.575 10.926C2.49167 10.5593 2.42933 10.1593 2.388 9.726C2.34667 9.29267 2.32567 8.826 2.325 8.326C2.325 5.926 2.8 3.93867 3.75 2.364C4.7 0.789333 5.89167 0.00133333 7.325 0C8.19167 0 8.9 0.321 9.45 0.963C10 1.605 10.275 2.50067 10.275 3.65C10.275 5.08333 9.821 6.5 8.913 7.9C8.005 9.3 6.74233 10.5583 5.125 11.675C5.24167 11.7917 5.36267 11.8793 5.488 11.938C5.61333 11.9967 5.74233 12.0257 5.875 12.025C6.30833 12.025 6.81267 11.75 7.388 11.2C7.96333 10.65 8.484 9.925 8.95 9.025L10.775 9.875C10.6583 10.1583 10.5667 10.5 10.5 10.9C10.4333 11.3 10.4417 11.65 10.525 11.95C10.6917 11.8667 10.8877 11.725 11.113 11.525C11.3383 11.325 11.5673 11.075 11.8 10.775L13.375 12C12.9417 12.6 12.4417 13.0833 11.875 13.45C11.3083 13.8167 10.7833 14 10.3 14C9.95 14 9.63767 13.896 9.363 13.688C9.08833 13.48 8.859 13.159 8.675 12.725C8.20833 13.1417 7.73333 13.4583 7.25 13.675C6.76667 13.8917 6.28333 14 5.8 14Z" fill="#313131" />
                                    </svg>

                                    <span>Modify Request</span>
                                  </div>
                                </Dropdown.Item>
                              )}
                              {/* :(
                                 <Dropdown.Item
                                  onClick={() => handleSignatureRequest(item)}
                                  title="Request a signature for this document."
                                >
                                  <div className="dropdown-item-content">  <span>Modify Request</span>
                                  </div>
                                </Dropdown.Item>
                              ) */}
                              {canUserDeleteFile && (
                                <Dropdown.Item onClick={() => handleClickDelete(item)}>
                                  <div className="dropdown-item-content">
                                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M2.5 15C2.04167 15 1.64945 14.8369 1.32334 14.5108C0.997225 14.1847 0.833892 13.7922 0.833336 13.3333V2.5C0.597225 2.5 0.399447 2.42 0.240003 2.26C0.0805585 2.1 0.000558429 1.90222 2.87356e-06 1.66667C-0.000552682 1.43111 0.0794474 1.23333 0.240003 1.07333C0.400559 0.913333 0.598336 0.833333 0.833336 0.833333H4.16667C4.16667 0.597222 4.24667 0.399445 4.40667 0.24C4.56667 0.0805556 4.76445 0.000555556 5 0H8.33334C8.56945 0 8.7675 0.0800001 8.9275 0.24C9.0875 0.4 9.16723 0.597778 9.16667 0.833333H12.5C12.7361 0.833333 12.9342 0.913333 13.0942 1.07333C13.2542 1.23333 13.3339 1.43111 13.3333 1.66667C13.3328 1.90222 13.2528 2.10028 13.0933 2.26083C12.9339 2.42139 12.7361 2.50111 12.5 2.5V13.3333C12.5 13.7917 12.3369 14.1842 12.0108 14.5108C11.6847 14.8375 11.2922 15.0006 10.8333 15H2.5ZM10.8333 2.5H2.5V13.3333H10.8333V2.5ZM5 11.6667C5.23611 11.6667 5.43417 11.5867 5.59417 11.4267C5.75417 11.2667 5.83389 11.0689 5.83334 10.8333V5C5.83334 4.76389 5.75334 4.56611 5.59334 4.40667C5.43334 4.24722 5.23556 4.16722 5 4.16667C4.76445 4.16611 4.56667 4.24611 4.40667 4.40667C4.24667 4.56722 4.16667 4.765 4.16667 5V10.8333C4.16667 11.0694 4.24667 11.2675 4.40667 11.4275C4.56667 11.5875 4.76445 11.6672 5 11.6667ZM8.33334 11.6667C8.56945 11.6667 8.7675 11.5867 8.9275 11.4267C9.0875 11.2667 9.16723 11.0689 9.16667 10.8333V5C9.16667 4.76389 9.08667 4.56611 8.92667 4.40667C8.76667 4.24722 8.56889 4.16722 8.33334 4.16667C8.09778 4.16611 7.9 4.24611 7.74 4.40667C7.58 4.56722 7.5 4.765 7.5 5V10.8333C7.5 11.0694 7.58 11.2675 7.74 11.4275C7.9 11.5875 8.09778 11.6672 8.33334 11.6667Z" fill="#313131" />
                                    </svg>

                                    <span>Delete</span>
                                  </div>
                                </Dropdown.Item>
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </>
            )}
          </div>
        </div>
        {((attachments?.length ?? 0) > 0 || (attachmentRequirements?.length ?? 0) > 0) && canScrollRight && (
          <button
            className="attachment-slider-arrow attachment-slider-arrow-right"
            onClick={handleScrollRight}
            aria-label="Scroll right"
          >
            <SliderArrowIcon direction="right" filterId="filter_arrow_right" />
          </button>
        )}
      </div>

      {showUploadFileModal && (
        <UploadFileModal
          handleCloseUploadFileModal={handleCloseUploadFileModal}
          showUploadFileModal={showUploadFileModal}
          refreshAttachments={refreshAttachments}
          authToken={authToken}
          taskId={taskId}
          attachment={selectedRequiredFile}
        />
      )}
      {showExternalFileUploadModal && (
        <ExternalFileRequestModal
          showExternalFileReqeustModal={showExternalFileUploadModal}
          handleCloseExternalFileReqeustModal={() =>
            setShowExternalFileUploadModal(false)
          }
          taskId={Number(taskId)}
          // ak 
          onSuccess={() => refreshAttachments()}
        />
      )}
      <Modal
        show={showRequestAttachmentModal}
        onHide={() => setShowRequestAttachmentModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Request Template Attachment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Select Template(s)</Form.Label>
            <Select
              isMulti
              closeMenuOnSelect={false}
              options={templateFileOptions}
              value={templateFileOptions.filter((o) =>
                selectedTemplateFiles.includes(o.value)
              )}
              onChange={(selected: any) =>
                setSelectedTemplateFiles(selected.map((s: any) => s.value))
              }
              placeholder="Choose files..."
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Comment</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Add a comment for the request..."
              value={requestComment}
              onChange={(e: any) => setRequestComment(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowRequestAttachmentModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleRequestAttachment}
            disabled={
              isRequestingAttachment || selectedTemplateFiles.length === 0
            }
          >
            {isRequestingAttachment ? (
              <Spinner animation="border" size="sm" />
            ) : (
              "Submit Request"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default TaskAttachmentSection;
